import React from 'react';
import { WrenchIcon, ListChecksIcon, LayoutGridIcon, RepeatIcon } from 'lucide-react';
const items = [{
  icon: WrenchIcon,
  title: 'Visual diagnostic resources',
  text: 'Find the right visual fault-finding reference when you need it.'
}, {
  icon: ListChecksIcon,
  title: 'Structured diagnostic paths',
  text: 'Move from symptom to possible cause through a more structured process.'
}, {
  icon: LayoutGridIcon,
  title: '6 diagnostic areas',
  text: 'Workflow, fuel, turbo, electrical, emissions and advanced diesel faults.'
}, {
  icon: RepeatIcon,
  title: 'Ready to use again and again',
  text: 'Return to the tools whenever a new diesel problem appears.'
}];
export function Differentiation() {
  return <section className="bg-white px-5 py-7" data-id="element-18" data-mp="2nozpi6hah1t0">
      <div className="mx-auto max-w-[520px] text-center" data-id="element-19" data-mp="2nn6eyg3k1xfq">
        <h2 className="font-display text-[19px] uppercase leading-[1.05] text-navy md:text-[21px]" data-id="element-20" data-mp="ybe1a5emz877">This isn’t just another diesel ebook</h2>
        <p className="mt-1 font-display text-[17px] uppercase leading-tight text-navy md:text-[19px]" data-id="element-21" data-mp="tdcmhwo8tv1j">
          It’s a <span className="bg-gold px-1" data-id="element-22" data-mp="n2kipci39woc">ready-to-use diagnostic system</span>
        </p>
        <ul className="mt-4 grid gap-2.5 text-left sm:grid-cols-2" data-id="element-23" data-mp="s1dzbdsoa3sq">
          {items.map(({
          icon: Icon,
          title,
          text
        }) => <li key={title} className="flex gap-2.5 rounded-[3px] border border-line bg-paper px-3 py-2.5" data-id="element-24" data-mp="10vjylfls9swf">
              <Icon className="mt-0.5 h-4 w-4 shrink-0 text-muted" aria-hidden="true" data-id="element-25" data-mp="15vephj5k6ihh" />
              <div data-id="element-26" data-mp="1atpyxsrxyqz6">
                <h3 className="font-display text-[11.5px] uppercase leading-tight text-navy" data-id="element-27" data-mp="1at6pz1k9rcxa">{title}</h3>
                <p className="mt-0.5 text-[10.5px] leading-snug text-muted" data-id="element-28" data-mp="1fu46l9pmrywo">{text}</p>
              </div>
            </li>)}
        </ul>
        <p className="mt-4 font-display text-[12px] uppercase tracking-[0.03em] text-navy" data-id="element-29" data-mp="1jsjz1t4hdzhh">Less searching. Less guessing. More structure.</p>
      </div>
    </section>;
}